import React from 'react';
import PropTypes from 'prop-types';
import './ErrorMessage.css';

const ErrorMessage = props => {
  const { heading, body } = props;
  return (
    <div className="error-message__container">
      <h2 className="error-message__heading">{heading}</h2>
      <p>{body}</p>
    </div>
  );
};

ErrorMessage.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.string
};

ErrorMessage.defaultProps = {
  heading: 'Sorry, something went wrong on our end',
  body:
    "We're working to fix the issue. If refreshing the page doesn't help, please try again later."
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/ErrorMessage.js